import { jsx as _jsx } from "react/jsx-runtime";
var Icon = function (_a) {
    var icon = _a.icon, onClick = _a.onClick;
    return _jsx("i", { onClick: onClick, className: "fas fa-".concat(icon) }, icon);
};
export default Icon;
